import styled from 'styled-components';

export const ListViewContainer = styled.div`
  height: 100%;

  > div > div > div:first-child {
    overflow-x: visible;
  }
`;
